import React from 'react';
import { CmsValue } from 'core/type/BootstrapConfig.types';
import { PriceFormatter, StringFormatter } from '@agoda/react-handyman';
import { Box, Typography } from '@drone-js/core';
import { parseNumber } from 'core/utils/parseNumber';
import { DisplayPromocodeItem } from 'gql/autogen/DisplayPromocodeItem';

export interface DiscountInfoTextProps {
    discountItem: DisplayPromocodeItem;
    currency: string | undefined;
    locale: string;
    cms: CmsValue;
}

const DiscountInfoText: React.FC<DiscountInfoTextProps> = (props) => {
    const { cms, currency, locale, discountItem } = props;
    const { discountedValue, promotionCode, isApplied } = discountItem;

    if (!discountItem || !discountedValue || !promotionCode || !isApplied) return null;

    const title = StringFormatter.format(cms[344461], promotionCode);
    const displayAmount = PriceFormatter.format(parseNumber(discountedValue), locale, {
        isSpaceBetweenSymbolAndCurrency: true,
        decimalPlaces: 2,
        currency,
    });

    return (
        <Box display="flex" justifyContent="space-between" width="100%" pb="12" data-testid="discount-info-text">
            <Typography variant="body-s-strong" textColor="feedback.positive">
                {title}
            </Typography>
            <Typography variant="body-s" textColor="feedback.positive">
                {displayAmount}
            </Typography>
        </Box>
    );
};

DiscountInfoText.displayName = 'DiscountInfoText';

export default DiscountInfoText;
